import React from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import PublisherLayout from '../components/PublisherLayout';
import PublisherDashboard from './PublisherDashboard';
import PublisherOffers from './PublisherOffers';
import PublisherDailyReport from './PublisherDailyReport';
import PublisherEventReport from './PublisherEventReport';
import PlaceholderPage from './PlaceholderPage';
import './AdminPublisherView.css';

/**
 * AdminPublisherView - Allows admin to view publisher dashboard
 * This is a read-only view for admins to see what publishers see
 */
const AdminPublisherView: React.FC = () => {
  const params = useParams<{ id: string; '*': string }>();
  const id = params.id;
  const section = params['*'] || 'dashboard';
  const location = useLocation();
  const navigate = useNavigate();
  const publisherName = location.state?.publisherName || `Publisher #${id}`;

  const handleBackToAdmin = () => {
    navigate('/affiliates');
  };

  // Convert ID to number for publisher lookup
  const publisherId = id || '';
  const basePath = `/publisher-view/${publisherId}`;

  const renderPreviewPage = () => {
    switch (section) {
      case '':
      case 'dashboard':
        return <PublisherDashboard publisherUsername={publisherId} />;
      case 'offers':
        return <PublisherOffers publisherUsername={publisherId} />;
      case 'daily-report':
        return <PublisherDailyReport publisherIdOverride={publisherId} />;
      case 'event-report':
        return <PublisherEventReport publisherIdOverride={publisherId} />;
      case 'install-report':
        return <PlaceholderPage title="Install Report" />;
      default:
        return <PublisherDashboard publisherUsername={publisherId} />;
    }
  };

  return (
    <div className="admin-publisher-view">
      {/* Admin Banner */}
      <div className="admin-banner">
        <div className="admin-banner-content">
          <span className="admin-badge">ADMIN VIEW (Read-Only)</span>
          <span className="viewing-as">Viewing as: <strong>{publisherName}</strong> (ID: {publisherId})</span>
          <button className="btn-back-admin" onClick={handleBackToAdmin}>
            ← Back to Admin Dashboard
          </button>
        </div>
      </div>

      {/* Publisher Dashboard View */}
      <div className="publisher-view-container">
        <PublisherLayout
          onLogout={handleBackToAdmin}
          publisherName={publisherName}
          isAdminView={true}
          basePath={basePath}
        >
          {renderPreviewPage()}
        </PublisherLayout>
      </div>
    </div>
  );
};

export default AdminPublisherView;
